import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtro'
})
export class FiltroPipe implements PipeTransform {

  transform(value: any[], campos: string[], termino: string): any {
	  if (!value || !termino) {
		  return value;
	  }

	  if (campos.length == 0) {
		  if(value.length > 0) {
			Object.keys(value[0]).forEach(key => {
				try{
					//Intento pasarlo a minúscula. Si se puede se agrega a los campos que puede buscar, si no lo saltea.
					let Valor = value[0][key].toString().toLowerCase();
					campos.push(key);
				}
				catch { }
			});
		}
	  }

	  termino = termino.toLowerCase();

	  return value.filter(item => {
		  let Devolver = false;

		  for (let c of campos) {
			  if (!Devolver) {
				  let Valor: string = item[c].toString();
				  Valor = Valor.toLowerCase();

				  Devolver = (Valor.indexOf(termino) > -1);
			  }
		  }

		  return Devolver;
	  });
  }

}
